/**
 * Show the correct tabs and active tab buttons
 *     - Get element
 *     - Add click listener to the tab buttons
 */
export default function tripPriceTabs() {
  const tabsButtons = document.querySelectorAll('.trip-prices__tab-title-label');
  const tabsContents = document.querySelectorAll('.trip-prices__tab-content');

  if (!tabsButtons && !tabsContents) return;

  tabsButtons.forEach((tabsButton) => {
    tabsButton.addEventListener('click', () => {
      if (!tabsButton.classList.contains('trip-prices__tab-title-label--active')) {
        updateTabsContents(tabsButton.getAttribute('for').trim(), tabsContents);
        updateTabsButtons(tabsButton, tabsButtons);
      }
    });
  });
}

/**
 * Update the active tabs content section
 *
 * @param targetIdentifier
 * @param tabsContents
 */
function updateTabsContents(targetIdentifier, tabsContents) {
  tabsContents.forEach((tabsContent) => {
    const contentIdentifier = tabsContent.getAttribute('data-tab').trim();
    if (targetIdentifier === '1-0' || targetIdentifier === '1-1' || contentIdentifier === targetIdentifier) {
      tabsContent.classList.add('trip-prices__tab-content--active');
    } else {
      tabsContent.classList.remove('trip-prices__tab-content--active');
    }
  });
}

/**
 * Update the active tabs button
 *
 * @param clickedButton
 * @param tabsButtons
 */
function updateTabsButtons(clickedButton, tabsButtons) {
  tabsButtons.forEach((tabsButton) => {
    if (tabsButton === clickedButton) {
      tabsButton.classList.add('trip-prices__tab-title-label--active');
    } else {
      tabsButton.classList.remove('trip-prices__tab-title-label--active');
    }
  });
}
